import React,{ useEffect, useState }  from "react";


const AnimatedDigit = ({ targetDigit }) => {
  const [currentDigit, setCurrentDigit] = useState(0);

  useEffect(() => {
    if (currentDigit === targetDigit) return;
    const step = targetDigit > currentDigit ? 1 : -1;
    const interval = setInterval(() => {
      setCurrentDigit(prev => {
        if (prev === targetDigit) {
          clearInterval(interval);
          return prev;
        }
        return prev + step;
      });
    }, 100);
    return () => clearInterval(interval);
  }, [targetDigit, currentDigit]);

  return (
    <span style={{
      display: "inline-block",
      transition: "transform 0.3s, opacity 0.3s",
      transform: "scale(1.2)",
      opacity: 1
    }}>
      {currentDigit}
    </span>
  );
};

export default AnimatedDigit;
